import { prepareServiceEnv, prepareServicesEnv, readConfiguration } from "@excitare/cli-config";
import { IServiceEnv } from "@excitare/cli-types";
import { Dashboard } from "@excitare/dashboard";
import { PubSubEventData, PubSubEvents, PubSubServer } from "@excitare/pubsub";
import { dirname, join, resolve } from "path";
import { URL } from "url";

import { getCurrentTerminals } from "./fork/terminal";
import { LocalService } from "./local/service";
import { localServices } from "./local/services";
import { Proxy } from "./proxy";

let pubSubServerInstance: PubSubServer | null;
export const pubSubServer = () => {
  if (pubSubServerInstance == null) {
    const instance = new PubSubServer(socket => {
      for (const entry of localServices.serviceData.values()) {
        instance.emitOnSocket(socket, PubSubEvents.ClientInfo, {
          ...entry
        } as PubSubEventData.ClientInfo);
      }
    });
    pubSubServerInstance = instance;
  }
  return pubSubServerInstance;
};

export async function startLocalExcitare(
  proxyPort: number,
  dashboardPort: number,
  inspect: boolean
) {
  const dashboard = new Dashboard();
  const { io } = dashboard.listen(dashboardPort);
  // require("opn")("http://localhost:" + args.dashboardPort);

  io.on("connection", socket => {
    socket.emit("terms", getCurrentTerminals().map(el => ({ name: el.name, tags: el.tags })));
  });

  let env!: IServiceEnv;
  try {
    env = await prepareServicesEnv(
      "development",
      "local",
      new URL(`http://localhost:${proxyPort}`).origin,
      join(process.cwd(), "./.env")
    );
  } catch (err) {
    console.error(err);
    process.exit(1);
  }

  const { services } = readConfiguration("local", process.cwd());
  const builds: Array<Promise<LocalService>> = [];
  let currentServicePort = 3000;
  for (const service of services) {
    const localService = localServices.create(
      service,
      currentServicePort++,
      io,
      prepareServiceEnv(service, env),
      inspect
    );
    builds.push(localService);
  }

  const built = await Promise.all(builds);
  console.log("Builds finished");
  for (const localService of built) {
    await localService.boot();
    console.log(
      "Service %s is running\n - port: %s\n - token: %s",
      localService.currentData.name,
      localService.currentData.port,
      localService.currentData.token
    );
  }

  const proxy = new Proxy(proxyPort, built);
  proxy.listen();

  pubSubServer().on(PubSubEvents.ClientInfo, message => {
    const existing = localServices.byName(message.name);
    if (existing == null || message.port !== existing.port) {
      proxy.listen();
    }
  });

  function cleanup(code: any) {
    console.log(`\nAbout to exit with code: ${code}`);

    for (const service of built) {
      service.stop();
    }
    proxy.close();
  }

  process.on("SIGINT", code => {
    cleanup(code);
    process.exit();
  });
  process.on("SIGTERM", cleanup);
  process.on("exit", cleanup);
}
